import { Calendar } from 'primereact/calendar';
import type { CalendarPropsSingle } from 'primereact/calendar';
import React, { useState } from 'react';
import { COMPONENT_SIZE } from '../../../constants';

// Flattened Calendar props that accept any selectionMode without discriminated union issues
type AnyModeCalendarProps = Omit<CalendarPropsSingle, 'selectionMode' | 'onChange' | 'value'> & {
  selectionMode?: 'single' | 'multiple' | 'range';
  onChange?: CalendarPropsSingle['onChange'];
  value?: Date | Date[] | (Date | null)[] | null;
  key?: number;
};
const AnyCalendar = Calendar as React.ComponentType<AnyModeCalendarProps>;

// Extend CalendarProps to properly support all selection modes
export type AppCalendarProps = Omit<
  CalendarPropsSingle,
  'label' | 'selectionMode' | 'onChange' | 'value'
> & {
  label?: string;
  error?: string;
  size?: COMPONENT_SIZE;
  invalid?: boolean;
  selectionMode?: 'single' | 'multiple' | 'range';
  onChange?: CalendarPropsSingle['onChange'];
  value?: Date | Date[] | (Date | null)[] | null;
};

const AppCalenderInput: React.FC<AppCalendarProps> = ({
  error,
  label,
  size,
  required,
  onHide,
  selectionMode = 'single',
  invalid,
  onChange,
  ...props
}) => {
  const sizeClass = size ? `p-calendar-${size}` : '';
  const invalidClass = invalid || error ? 'p-invalid' : '';
  const className = `${props.className || ''} ${sizeClass} ${invalidClass}`.trim();
  const [calendarKey, setCalendarKey] = useState(0);

  const handleHide = () => {
    // Only increment key for single date selection, not for range or multiple
    // Range/multiple selection needs to persist between selections
    if (!selectionMode || selectionMode === 'single') {
      setCalendarKey((prevKey) => prevKey + 1);
    }
    if (onHide) {
      onHide();
    }
  };

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="label-text">
          {label} {required && <span className="p-error">*</span>}
        </label>
      )}
      <AnyCalendar
        key={calendarKey}
        {...props}
        selectionMode={selectionMode}
        onChange={onChange}
        onHide={handleHide}
        className={className}
      />
      {error && <small className="p-error">{error}</small>}
    </div>
  );
};

export default AppCalenderInput;
